import { render, staticRenderFns } from "./EducationComponent.vue?vue&type=template&id=6eb41f30&scoped=true&"
import script from "./EducationComponent.vue?vue&type=script&lang=js&"
export * from "./EducationComponent.vue?vue&type=script&lang=js&"
import style0 from "./EducationComponent.vue?vue&type=style&index=0&id=6eb41f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb41f30",
  null
  
)

export default component.exports